import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=46ecd4a4&scoped=true&"
import script from "./JobDetail.vue?vue&type=script&lang=ts&"
export * from "./JobDetail.vue?vue&type=script&lang=ts&"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=46ecd4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ecd4a4",
  null
  
)

export default component.exports